import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    promotions: Array<{ code: string; type: string }>;
    removePromotionCode: (code: string) => void;
};

export const PromotionList = ({ promotions, removePromotionCode }: Props) => {
    const { t } = useGranite();

    const ActiveDiscount = ({ code, onClick }: any) => (
        <div className={cn("tw:m-0 tw:p-0")}>
            <span className={cn("tw:uppercase")}>{code}</span>
            <Button
                onClick={onClick}
                className={cn("tw:m-0 tw:p-0 tw:ml-2 tw:align-baseline")}
                type="button"
                color="link"
                aria-label={t("general.button.delete")}
            >
                <i className={cn("tw:hover:cursor-pointer las la-trash")} />
            </Button>
        </div>
    );

    if (promotions.length === 0) {
        return null;
    }

    return (
        <div className={cn("tw:text-primary tw:mb-4 tw:sm:pt-2 tw:pt-0")}>
            <h6 className={cn("tw:mt-3 tw:text-dark tw:font-bold")}>
                {t("general.checkout.discount.label.activeDiscounts")}
            </h6>
            <div>
                {promotions.map((promotion, index) => (
                    <ActiveDiscount
                        key={index}
                        code={promotion.code}
                        onClick={() => removePromotionCode(promotion.code)}
                    />
                ))}
            </div>
        </div>
    );
};
